import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthService } from 'src/app/api/services/auth.service';
import { homeFor } from 'src/app/guards/role.guard';

/**
 * Where a successful login lands, for the instant it takes to work out where
 * the person actually belongs.
 *
 * This replaces the "are you a customer or a bar owner?" selection screen. That
 * screen asked the user to declare something the token already states, and by
 * offering the bar dashboard to everyone it put staff screens one click away
 * from any customer. Roles are not a preference, so they are no longer a choice.
 *
 * Nobody should ever see this for more than a moment; it renders a spinner only
 * so the redirect does not flash an empty page.
 */
@Component({
  selector: 'app-post-login',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  template: `
    <div class="flex flex-col items-center justify-center min-h-[60vh] gap-4">
      <mat-spinner diameter="40"></mat-spinner>
      <p class="text-gray-600">{{ message }}</p>
    </div>
  `,
})
export class PostLoginComponent implements OnInit {
  message = 'Signing you in…';

  constructor(private auth: AuthService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    const type = await this.auth.getCurrentUserType().catch(() => null);

    if (!type) {
      // The token said nothing about who this is. Rather than guess a
      // destination, send them back to sign in.
      this.message = 'We could not confirm your account — taking you to sign in.';
      this.router.navigate(['/login']);
      return;
    }

    // replaceUrl so Back does not bounce the user through this redirect again.
    this.router.navigate([homeFor(type)], { replaceUrl: true });
  }
}
